import React from 'react';
import { Layout, Button } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useAppStore } from '../store';
import './Header.scss';

const Header = () => {
  const sidebarCollapsed = useAppStore((state) => state.sidebarCollapsed);
  const toggleSidebar = useAppStore((state) => state.toggleSidebar);

  return (
    <Layout.Header className="header">
      <Button
        type="text"
        icon={sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={toggleSidebar}
        className="sidebar-toggle"
      />
      <div className="header-content">
        <h1>NOVA Billing - Sistema de Gestión de Facturas y Cobranzas</h1>
      </div>
    </Layout.Header>
  );
};

export default Header;
